import { useNavigate } from 'react-router-dom';
import { MODAL_TYPES } from '@components/modals';
import { Button } from '@components/primitives/Button';
import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { useSubjectLanguageVariants } from '@features/user';
import { useEventTracking } from '@services/statsig';
import { useModal } from '@store/hooks';
import { publicAsset } from '@utils/publicAsset';

import PatientIcon from '../../assets/patient.svg?react';
import { useHasRealPatients } from '../../hooks/useHasRealPatients';

import { CardImg } from './shared/CardImg';

export const PatientCard = () => {
  const navigate = useNavigate();
  const { singularCap: subjectLanguage, pluralCap: subjectLanguagePlural } =
    useSubjectLanguageVariants();
  const { dashboard } = useEventTracking();
  const { open: openModal } = useModal();
  const { hasRealPatients, isLoading } = useHasRealPatients();

  const handleCreatePatient = () => {
    dashboard.actionClicked({
      action_type: 'create_patient',
      source: 'dashboard_v2_card',
    });

    // Open the new patient modal
    openModal(MODAL_TYPES.NEW_PATIENT, {
      source: 'dashboard_v2_card',
      navigateToPatients: true,
    });
  };

  const handleManagePatients = () => {
    dashboard.actionClicked({
      action_type: 'manage_patients',
      source: 'dashboard_v2_card',
    });

    // Navigate to the patients page
    navigate('/patients');
  };

  // Determine which action to show based on patient state
  const handleAction = hasRealPatients ? handleManagePatients : handleCreatePatient;
  const actionLabel = hasRealPatients
    ? `Manage ${subjectLanguagePlural}`
    : `Create your First ${subjectLanguage}`;

  return (
    <FeatureCard
      icon={<PatientIcon width={20} height={20} fill="currentColor" />}
      title={`Manage ${subjectLanguage} Profiles`}
      fullHeight
      onClick={handleAction}
      action={<Button disabled={isLoading}>{actionLabel}</Button>}
    >
      <CardImg
        src={publicAsset('/dashboard/home-tile_patient-profile.png')}
        alt={`Manage ${subjectLanguage} Profile`}
      />
    </FeatureCard>
  );
};
